<div class="row">
  <!-- col 1 -->

  <div class="sm:tw-w-1/2 xl:tw-w-1/3">
    <!-- organizationId -->
    <list-group-item
      label="common.organizationId"
      [value]="model.organizationId"
    >
    </list-group-item>

    <!-- organization -->
    <list-group-item
      label="common.organization"
      [value]="model.organizationName"
    >
    </list-group-item>

    <!-- currentCredit -->
    <list-group-item [label]="fields + 'currentCredit'" [isShowValue]="false">
      <div
        class="badge badge-light border dir-ltr tw-text-gray-800 tw-text-[13px] text-wrap"
        content
        [credit]="model.currentCredit"
      >
        <div class="credit-number">
          <span class="credit-number-text">
            {{ model.currentCredit | numberSeparator }}
          </span>
        </div>
      </div>
    </list-group-item>

    <!-- transactionKind -->
    <list-group-item
      label="common.transactionKind"
      [value]="model.transactionKind"
    >
    </list-group-item>

    <!-- typeCreditChange -->
    <list-group-item
      [label]="fields + 'typeCreditChange'"
      [value]="
        model.typeCreditChange | enumToText : TypeCreditChangesEnumValues
      "
    >
    </list-group-item>
  </div>

  <!-- col 2 -->
  <div class="sm:tw-w-1/2 xl:tw-w-1/3">
    <!-- amount -->
    <list-group-item
      label="common.amount"
      [value]="model?.amount | numberSeparator"
    >
    </list-group-item>

    <!-- createdAt -->
    <list-group-item label="common.createDate" [isShowValue]="false">
      <div
        class="badge badge-light border dir-ltr tw-text-gray-800 tw-text-[13px] text-wrap"
        content
      >
        <span class="dir-ltr">
          {{
            model.createdAt
              | dateTimeWithSecondConvertor
                : translationService.currentLang() || "fa"
          }}
        </span>
      </div>
    </list-group-item>

    <!-- outboxId -->
    <list-group-item [label]="fields + 'outboxId'" [value]="model.outboxId">
    </list-group-item>

    <!-- packageId -->
    <list-group-item [label]="fields + 'packageId'" [value]="model.packageId">
    </list-group-item>

    <!-- typeTransaction -->
    <list-group-item [label]="fields + 'typeTransaction'" [isShowValue]="false">
      <span class="badge badge-light border" content>
        <i
          [transactionTypeIcon]="model.typeTransaction"
          [matTooltip]="
            model.typeTransaction | enumToText : TypeTransactionsEnumValues
          "
        ></i>
      </span>
    </list-group-item>
  </div>

  <!-- col 3 -->
  <div class="sm:tw-w-1/2 xl:tw-w-1/3">
    <!-- packageTitle -->
    <list-group-item
      [label]="fields + 'packageTitle'"
      [value]="model.packageTitle"
    >
    </list-group-item>

    <!-- paymentId -->
    <list-group-item [label]="fields + 'paymentId'" [isShowValue]="false">
      <div
        class="badge badge-light border dir-ltr tw-text-gray-800 tw-text-[13px] text-wrap"
        content
      >
        <span class="dir-ltr">
          {{ model.paymentId | checkValueLessThanZero }}
        </span>
      </div>
    </list-group-item>

    <!-- description -->
    <div
      class="list-group-item tw-border tw-border-gray-100 dark:tw-border-dark-100 dark:tw-bg-dark-300 tw-rounded-md tw-flex tw-justify-start flex-column tw-py-4 log-text sms-text"
    >
      <div
        class="tw-flex tw-justify-start tw-items-center border-bottom dark:tw-border-dark-100 tw-pb-2"
      >
        <span class="tw-font-medium tw-text-gray-700 dark:tw-text-gray-300">{{
          "common.description" | translate
        }}</span>
      </div>
      <div
        class="tw-pt-5 tw-text-gray-600 dark:tw-text-gray-200 dir-rtl"
        copyToClipboard
      >
        {{ model.description }}
      </div>
    </div>
  </div>
</div>
